<ngb-toast
  *ngIf="showToast"
  class="toast-custom"
  header="Error"
  [autohide]="false"
  (hidden)="(null)">
  <b>Message</b>
  <p *ngIf="errorLogs.errorMessage">{{ errorLogs.errorMessage }}</p>
</ngb-toast>
